function RequestNewSample(){
    return ( 
        <>
        <h1>Request New Sample component</h1>
        </>
    ); 
    }
    
    export default RequestNewSample;